import { scrollToFirstInvalidFormControl } from '@manager/utils/form-utils';
import type { App } from 'vue';

const formErrorSelector =
  '.v-input--error, .v-field--error, [aria-invalid="true"]' as const;

let isInitialized = false;
const processingForms = new WeakSet<HTMLFormElement>();

export function formErrorFeedbackInit(app: App) {
  if (isInitialized || typeof window === 'undefined') {
    return;
  }

  isInitialized = true;

  function submitHandler(event: Event) {
    const target = event.target;

    if (!(target instanceof HTMLFormElement)) return;
    if (!target.classList.contains('v-form')) return;
    if (processingForms.has(target)) return;

    const form = target;
    processingForms.add(form);

    // Wait until Vuetify has finished updating validation state/classes
    requestAnimationFrame(() => {
      if (!form.querySelector(formErrorSelector)) {
        processingForms.delete(form);
        return;
      }

      scrollToFirstInvalidFormControl(form);

      // Allow new triggers after animation duration (220ms) + buffer
      setTimeout(() => {
        processingForms.delete(form);
      }, 300);
    });
  }

  document.addEventListener('submit', submitHandler, true);

  const originalUnmount = app.unmount;
  app.unmount = (...args) => {
    document.removeEventListener('submit', submitHandler, true);
    originalUnmount(...args);
  };
}
